import Heart from '@assets/icons/heart.svg'
import { Icon } from './Icon'

export const HeartIcon = Icon(Heart)
